import { Employee } from "../employee-list";
import React from "react";
import profileImg from ".././media/amelie-korn.jpg";
import i18n from "../../../generic/i18n";

export const amelieKorn: Employee = {
  slug: "amelie-korn",
  displayName: "Amelie Korn",
  displayNameSuffix: "",
  title: "lawyer-female",
  isExternal: false,
  subTitle: "",
  awards: [],
  img: profileImg,
  languages: ["deu", "eng"],
};
